module.exports = __webpack_public_path__ + "static/img/twjd-sdo21.e356822.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo21.png
// module id = 863
// module chunks = 0